<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'app',
};
</script>

<style>
#app {
  font-family: '微软雅黑', 'Microsoft YaHei', '黑体', '宋体', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #333;
  min-height: 100vh;
}
@media(min-width: 769px) and (max-width: 1201px) {
  #app {
    width: 1200px;
  }
}
</style>
